import type { StateCreator } from "zustand";
import type { CenterStageTabId } from "@/components/features/center-stage/shared/types/center-stage";

export interface CenterStageSlice {
  isOpen: boolean;
  openTab: CenterStageTabId | null;
  canClose: boolean;
  showCloseDialog: boolean;
  pendingNavigation: string | null;
  setIsOpen: (isOpen: boolean) => void;
  setOpenTab: (tab: CenterStageTabId | null) => void;
  setCanClose: (canClose: boolean) => void;
  setShowCloseDialog: (showCloseDialog: boolean) => void;
  setPendingNavigation: (path: string | null) => void;
}

export const createCenterStageSlice: StateCreator<
  CenterStageSlice,
  [["zustand/devtools", never]],
  [],
  CenterStageSlice
> = (set) => ({
  isOpen: false,
  openTab: null,
  canClose: true,
  showCloseDialog: false,
  pendingNavigation: null,
  setIsOpen: (isOpen) => set({ isOpen }),
  setOpenTab: (openTab) => set({ openTab }),
  setCanClose: (canClose) => set({ canClose }),
  setShowCloseDialog: (showCloseDialog) => set({ showCloseDialog }),
  setPendingNavigation: (pendingNavigation) => set({ pendingNavigation }),
});
